import { render, staticRenderFns } from "./SaveWholesalerForm.vue?vue&type=template&id=2e0db6ee&"
import script from "./SaveWholesalerForm.vue?vue&type=script&lang=js&"
export * from "./SaveWholesalerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports